import React, { createContext, useContext } from "react";

// A minimal client-side router — this app only has 3 routes (/, /admin,
// /profile), so a full router library would be overkill. This just gives
// every page a `navigate(path)` function that updates the URL via
// history.pushState and swaps the rendered component, instead of a normal
// <a href> triggering a full browser page reload.
export const NavigationContext = createContext(() => {});

export function useNavigate() {
  return useContext(NavigationContext);
}

// Drop-in replacement for <a href="..."> for any IN-APP link — looks and
// behaves like a normal link (right-click / open-in-new-tab still work,
// since href is still set), but a plain click is intercepted to navigate
// client-side instead of reloading the page.
export function NavLink({ to, children, style, title }) {
  const navigate = useNavigate();
  return (
    <a
      href={to}
      title={title}
      onClick={(e) => {
        // Let modified clicks (open in new tab, etc.) behave normally.
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        navigate(to);
      }}
      style={style}
    >
      {children}
    </a>
  );
}
